import Column from '@components/Column';
import Image from '@components/Image';
import Text from '@components/Text';
import colors from '@constants/colors';
import { GiftBoxResponse } from '@models/gift';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import giftImg from './img.png';
import styles from './styles.module.scss';

interface Props {
    giftBox: GiftBoxResponse
}

function GiftInfo({ giftBox }:Props) {
    const { receiverName, giftCard, giftCoupon } = giftBox;
    const { t } = useTranslation('gift');
    return (
        <Column as='section' fullWidth
            className={styles.container}
            align='center' >
            <Image src={giftImg}
                className={styles.image}
                width={225}
                height={112}
                alt={t('giftInfo.imageAlt')} />
            <Text size='3xl'
                className={styles.comment}
                fontWeight='bold' >
                {t('giftInfo.sentMessage', { name: receiverName })}
            </Text>
            {giftCard && (
                <Fragment>
                    <Image src={giftCard.imageUrl}
                        className={styles.card}
                        width={200}
                        height={134}
                        alt='' />
                    <Text color={colors.gray7} size='xl' fontWeight='bold'
                        className={styles.name} >
                        {giftCard.name}
                    </Text>
                </Fragment>
            )}
            {giftCoupon && (
                <Fragment>
                    <div className={styles.item}>
                        <Image src={giftCoupon.imageUrl}
                            alt={giftCoupon.name}
                            width={72}
                            height={72} />
                    </div>
                    <Text color={colors.gray7} size='xl' fontWeight='bold'
                        className={styles.name} >
                        {giftCoupon.name}
                    </Text>
                </Fragment>
            )}
        </Column>
    );
}

export default GiftInfo;
